var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ft-car-placeholder"},[_c('div',{staticClass:"ft-slide"},[_c('div',{staticClass:"landscape"})]),_c('div',{staticClass:"vlt-pagination"},[_c('div',{staticClass:"brick"}),_c('div',{staticClass:"brick"}),_c('div',{staticClass:"brick"}),_c('div',{staticClass:"brick"}),_c('div',{staticClass:"brick"}),_c('div',{staticClass:"brick"})])])
}]

export { render, staticRenderFns }